import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/venue/manage/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/venue/manage/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/venue/manage/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/venue/manage/submit', params,options)

export const update = (params, options) =>
request.post('/api/venue/manage/update', params,options)

export const getAreaList = (params, options) =>
request.get('/api/venue/area/loadArea', Object.assign({}, options, { params }));

export const getVenueTypeList = (params, options) =>
request.get('/api/blade-system/dict/dictionaryWithIntKey?code=venue_type', Object.assign({}, options, { params }));
